<template>
  <div class="pagebar">
    <el-pagination
      :page-sizes="[10, 20, 50, 100, 300]"
      :current-page="page.page + (zeroBase ? 1 : 0)"
      :page-size="page.limit"
      :total="page.total"
      layout="total, sizes, prev, pager, next, jumper"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  props: {
    page: {
      type: Object,
      required: true,
    },
    zeroBase: {
      // 页码是否是从0开始的
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      autoScroll: true,
    };
  },
  methods: {
    handleCurrentChange(page) {
      if (this.zeroBase) {
        this.$emit("current-change", page - 1);
      } else {
        this.$emit("current-change", page);
      }
    },
    handleSizeChange(size) {
      this.$emit("size-change", size);
    },
  },
};
</script>

<style></style>
